import { ContractDurationType } from 'features/contracts/enums/contractDurationType';
import OptionType from 'features/shared/components/selectInput/OptionType';
import SelectInput from 'features/shared/components/selectInput/SelectInput';
import React from 'react';
import styles from './capacityYearSelect.module.scss';

interface Props {
  startDate: Date;
  endDate: Date;
  selectedYear: number;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const CapacityYearSelect = ({ startDate, endDate, selectedYear, onChange }: Props) => {
  // helpers
  const generateYears = (): OptionType[] => {
    let result: OptionType[] = [];
    let startYear = new Date(startDate).getFullYear();
    let endYear = new Date(endDate).getFullYear();

    for (let i = startYear; i <= endYear; i++) {
      result.push({
        value: i.toString(),
        name: i.toString(),
      });      
    }

    return result;
  }

  // render
  return (
    <div className={styles.capacitySelectItem}>
      <SelectInput 
        name="capacityYear"
        options={generateYears()}
        value={selectedYear}
        onChange={onChange}
        className="mb-0"
      />
    </div>
  )
}

export default CapacityYearSelect;
